import React, { forwardRef, useId } from "react";
import { FIELD_CLASS, FIELD_LABEL_CLASS } from "./fieldClass";
// 16px on mobile prevents iOS auto-zoom on focus; 44px min height for thumbs.
export const Input = forwardRef(({ className, title, value, onChange, marginTop = "mt-2", type, required, hint, error, id: idProp, ...otherProps }, ref) => {
    // Caller-supplied id is kept so an external <label htmlFor> (e.g. sr-only file inputs) still targets this field.
    const generatedId = useId();
    const id = typeof idProp === "string" && idProp !== "" ? idProp : generatedId;
    const hintId = `${id}-hint`;
    const hasError = !!error;
    return (<div className={marginTop}>
                {title && (<label htmlFor={id} className={FIELD_LABEL_CLASS}>
                        {title}
                        {required && (<span aria-hidden={"true"} className={"ml-0.5 text-danger"}>
                                *
                            </span>)}
                    </label>)}
                <input 
    // Spread before named props so the computed aria-* win; they fall back to the caller's value.
    {...otherProps} id={id} ref={ref} value={value} onChange={onChange} type={type || "text"} required={required} aria-invalid={hasError || otherProps["aria-invalid"] || undefined} aria-describedby={hint || error ? hintId : otherProps["aria-describedby"]} onWheel={(e) => {
            if (typeof otherProps.onWheel === "function") {
                otherProps.onWheel(e);
            }
            if (type === "number") {
                e.currentTarget.blur();
            }
        }} className={`
                    ${FIELD_CLASS}
                    ${hasError ? "border-danger! focus:border-danger! focus:ring-danger/25!" : ""}
                    ${className ? className : ""}
                `}/>
                {(error || hint) && (<p id={hintId} role={hasError ? "alert" : undefined} className={`mt-1 text-xs ${hasError ? "text-danger" : "text-gray-500"}`}>
                        {error || hint}
                    </p>)}
            </div>);
});
//# sourceMappingURL=input.jsx.map